const toProperCase = (word) => {
  var words = word.split('_')
  var results = []
  for (var i = 0; i < words.length; i++) {
    var letter = words[i].charAt(0).toUpperCase()
    results.push(letter + words[i].slice(1))
  }
  return results.join(' ')
}

const data = {
  l1: ['single', `35″ (89cm)`],
  l2: ['loveseat', `58″ (147cm)`],
  l3: ['straight_row_of_two', `64″ (163cm)`],
  l4: ['curved_row_of_two', `69″ (175cm)`],
  l5: ['three_seat_sofa', `81″ (206cm)`],
  l6: ['straight_row_of_three', `93″ (236cm)`],
  l7: ['curved_row_of_three', `103″ (262cm)`],
  l8: ['double_loveseat', `110″ (320cm)`],
  l9: ['curved_double_loveseat', `115″ (292cm)`],
  l10: ['straight_flanked_loveseat', `116″ (295cm)`],
  l12: ['curved_flanked_loveseat', `126″ (320cm)`],
  l11: ['straight_row_of_four', `122″ (310cm)`],
  l13: ['curved_row_of_four', `137″ (348cm)`],
  l14: ['straight_row_of_five', `151″ (384cm)`],
  l15: ['curved_row_of_five', `171″ (434cm)`],
  l16: ['captains_chair_double_loveseat', `156" , 396cm`],
}

const front_longue_data = [
  {
      "image": "single1-chaise",
      "buttonName": "Single Chaise",
      "node": "single1-chaise",
      "width": "35″ (89cm)"
  },
  {
      "image": "loveseat1-chaise",
      "buttonName": "Loveseat Chaise",
      "node": "loveseat1-chaise",
      "width": "58″ (147cm)"
  },
  {
      "image": "three_seat_sofa1-chaise",
      "buttonName": "Three Seat Sofa Chaise",
      "node": "three_seat_sofa1-chaise",
      "width": "81″ (206cm)"
  },
  {
      "image": "chaise_and_recliner",
      "buttonName": "Chaise + Recliner",
      "node": "chaise_and_recliner",
      "width": "64″ (163cm)"
  },
  {
      "image": "double_chaise",
      "buttonName": "Double Chaise",
      "node": "double_chaise",
      "width": "64″ (163cm)"
  },
  {
      "image": "side_chaise_and_two_recliners",
      "buttonName": "Side Chaise + 2 Recliners",
      "node": "side_chaise_and_two_recliners",
      "width": "93″ (236cm)"
  },
  {
      "image": "middle_chaise_and_two_recliners",
      "buttonName": "Middle Chaise + 2 Recliners",
      "node": "middle_chaise_and_two_recliners",
      "width": "93″ (236cm)"
  },
  {
      "image": "double_loveseat1-chaise",
      "buttonName": "Double Loveseat Chaise",
      "node": "double_loveseat1-chaise",
      "width": "110″ (320cm)"
  },
  {
      "image": "two_chaise_and_two_recliner",
      "buttonName": "Loveseat Chaise + 2 Recliners",
      "node": "loveseat1_chaise_and_two_recliners",
      "width": "116″ (236cm)"
  },
  {
      "image": "two_chaise_and_two_recliners",
      "buttonName": "2 Chaise + 2 Recliners",
      "node": "two_chaise_and_two_recliners",
      "width": "122″ (310cm)"
  },
  {
      "image": "quad_chaise",
      "buttonName": "Quad Chaise",
      "node": "quad_chaise",
      "width": "122″ (310cm)"
  },
  {
      "image": "three_chaise_and_two_recliners",
      "buttonName": "3 Chaise + 2 Recliners",
      "node": "three_chaise_and_two_recliners",
      "width": "151″ (384cm)"
  },
  {
      "image": "five_chaise",
      "buttonName": "5 Chaise",
      "node": "five_chaise",
      "width": "151″ (384cm)"
  },
  {
      "image": "double_loveseat_chaise_and_recliner",
      "buttonName": "Double Loveseat Chaise + Recliner",
      "node": "double_loveseat_chaise_and_recliner",
      "width": "156″ (396cm)"
  }
]

const data_front = [

  {
      "image": "l1",
      "buttonName": "Single",
      "node": "single1",
      "width": "35″ (89cm)"
  },
  {
      "image": "l2",
      "buttonName": "Loveseat",
      "node": "loveseat1",
      "width": "58″ (147cm)"
  },
  {
      "image": "l3",
      "buttonName": "Straight Row Of Two",
      "node": "straight_row_of_two1",
      "width": "64″ (163cm)"
  },
  {
      "image": "l4",
      "buttonName": "Curved Row Of Two",
      "node": "curved_row_of_two1",
      "width": "69″ (175cm)"
  },
  {
      "image": "l5",
      "buttonName": "Three Seat Sofa",
      "node": "three_seat_sofa1",
      "width": "81″ (206cm)"
  },
  {
      "image": "l6",
      "buttonName": "Straight Row Of Three",
      "node": "straight_row_of_three1",
      "width": "93″ (236cm)"
  },
  {
      "image": "l7",
      "buttonName": "Curved Row Of Three",
      "node": "curved_row_of_three1",
      "width": "103″ (262cm)"
  },
  {
      "image": "l8",
      "buttonName": "Double Loveseat",
      "node": "double_loveseat1",
      "width": "110″ (320cm)"
  },
  {
      "image": "l9",
      "buttonName": "Curved Double Loveseat",
      "node": "curved_double_loveseat1",
      "width": "115″ (292cm)"
  },
  {
      "image": "l10",
      "buttonName": "Straight Flanked Loveseat",
      "node": "straight_flanked_loveseat1",
      "width": "116″ (295cm)"
  },
  {
      "image": "l12",
      "buttonName": "Curved Flanked Loveseat",
      "node": "curved_flanked_loveseat1",
      "width": "126″ (320cm)"
  },
  {
      "image": "l11",
      "buttonName": "Straight Row Of Four",
      "node": "straight_row_of_four1",
      "width": "122″ (310cm)"
  },
  {
      "image": "l13",
      "buttonName": "Curved Row Of Four",
      "node": "curved_row_of_four1",
      "width": "137″ (348cm)"
  },
  {
      "image": "l14",
      "buttonName": "Straight Row Of Five",
      "node": "straight_row_of_five1",
      "width": "151″ (384cm)"
  },
  {
      "image": "l15",
      "buttonName": "Curved Row Of Five",
      "node": "curved_row_of_five1",
      "width": "171″ (434cm)"
  },
  {
      "image": "l16",
      "buttonName": "Captains Chair Double Loveseat",
      "node": "captains_chair_double_loveseat1",
      "width": "156\" , 396cm"
  }
]
const layouts_front = data_front.map(el => {
  const layout = {
    ...el,
    buttonImage: require(`../img/${el.image}.png`),
    // buttonImage: `../img/${k}.png`,
    // buttonName: toProperCase(data[k][0]),
    // node: data[k][0],
    // width: data[k][1],
  }
  return layout
})
console.log({layouts_front})
const layouts_front_longue = front_longue_data.map(el => {
  const layout = {
    ...el,
    buttonImage: require(`../img/${el.image}.png`),
    // buttonImage: `../img/${k}.png`,
    // buttonName: toProperCase(data[k][0]),
    // node: data[k][0],
    // width: data[k][1],
  }
  return layout
})
const layouts_back = Object.keys(data).map((k) => {
  const layout = {
    buttonImage: require(`../img/${k}.png`),
    buttonName: toProperCase(data[k][0]),
    node: data[k][0] + '2',
    width: data[k][1],
  }
  return layout
})
// console.log(layouts.map((l) => l.buttonName).join(', '))

export {layouts_front, layouts_back, layouts_front_longue}
